module.exports = __webpack_public_path__ + "img/41.7ee1533a.jpg";